var app = angular.module('tf.optionsCookbook', [])

    .controller('optionsCookbookCtrl', ['$scope', '$uibModalInstance', '$document', '$window', '$http', 'code', '$uibModal', 'asAt', 'expiries', 'currentUserService', function optionsCookbookController($scope, $uibModalInstance, $document, $window, $http, code, $uibModal, asAt, expiries, currentUserService) {

        $scope.code = code;
        $scope.sortType     = 'level'; // set the default sort type
        $scope.sortReverse  = false;  // set the default sort order
        $scope.expiries = expiries;
        $scope.strategyFilter = {
            price : null,
            volatility : null,
            time : null,
            level : null,
            noMargin : false,
            text : ''
        };

        $scope.filterStrategies = function(element, index, array) {
            var hasEquityLeg = element.legs[0].optionType == null;
            if (code === 'XJO' && hasEquityLeg) {
                return false;
            }

            if ($scope.strategyFilter.price && element.priceOutlook != $scope.strategyFilter.price) {
                return false;
            }

            if ($scope.strategyFilter.volatility && element.volOutlook != $scope.strategyFilter.volatility) {
                return false;
            }

            if ($scope.strategyFilter.time && element.timeImpact != $scope.strategyFilter.time) {
                return false;
            }

            if ($scope.strategyFilter.level && element.level != $scope.strategyFilter.level) {
                return false;
            }

            if ($scope.strategyFilter.noMargin && element.margins != 'no') {
                return false;
            }

            if ($scope.strategyFilter.text) {
                var matchesDescription = element.description.toLowerCase().indexOf($scope.strategyFilter.text.toLowerCase()) != -1;
                var matchesName = element.fullName.toLowerCase().indexOf($scope.strategyFilter.text.toLowerCase()) != -1;

                if (!matchesDescription && !matchesName) {
                    return false;
                }
            }

            return true;
        };

        $http.get('app/apps/optionsCookbook/strategies.json')
            .then(function(response) {
                $scope.strategies = response.data
                    .filter(s => s.feature == null || currentUserService.hasFeature(s.feature));
            })
            .catch(function(err) {
            // log error
        });

        $scope.strategyDetail = function(strategy) {
            $scope.focusedStrategy = strategy;
            $scope.showStrategyDetail = !$scope.showStrategyDetail;
            strategy.isShowStrategy = !strategy.isShowStrategy;
        };

        $scope.closeStrategyDetail = function() {
            if ($scope.focusedStrategy) {
                $scope.focusedStrategy.isShowStrategy = false;
            }
            $scope.focusedStrategy = null;
            $scope.showStrategyDetail = false;
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


        $scope.createStrategy= function(strategy) {
            $scope.openRecipeParameters(strategy);
        };

        $scope.openRecipeParameters = function(strategy) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/apps/optionsCookbook/optionRecipeParameters.tpl.html',
                controller: 'recipeParametersCtrl as recipeParametersCtrl',
                size: 'md',
                resolve: {
                    asAt: function() {
                        return asAt || moment().format("YYYY-MM-DD");
                    },
                    strategy: function () {
                        return strategy;
                    },
                    expiries : function() {
                        if (strategy.legs.length > 1) {
                            return $scope.expiries.filter(function(e) {
                                return e.expiryType != 'WEEKLY';
                            });
                        }
                        return $scope.expiries;
                    }
                }
            });
            modalInstance.result.then(function (strategyParams) {
                    var recipeParams = {
                        name: strategy.userInitial,
                        longName: strategy.fullName,
                        expiryDate: strategyParams.expiry.expiry || strategyParams.expiry.date,
                        code: $scope.code,
                        style: strategyParams.style,
                        legs: strategy.legs.map(function (leg) {
                            return {
                                optionType: leg.optionType,
                                priceWeight: leg.priceWeight,
                                size: leg.size,
                                timeOffset: leg.timeOffset || 0
                            };
                        })
                    };

                    $uibModalInstance.close(recipeParams);
                }
            );
        }

    }])

    .controller('stockSelectorCtrl', ['$rootScope', '$uibModalInstance', '$q', '$state', '$scope', '$uibModal', '$window', '$http', 'chainService', 'companyService',
        function stockController($rootScope, $uibModalInstance, $q, $state, $scope, $uibModal, $window, $http, chainService, companyService) {

        $scope.findCompanies = async function(input) {
            if ($scope.companies == null) {
                $scope.companies = await companyService.companies(true);
            }
            return companyService.findCompanies($scope.companies, input);
        };

        $scope.onCompanyChanged = function() {
            if (!$scope.company) {
                return
            }

            $uibModalInstance.close();

            var modalInstance = $uibModal.open({
                templateUrl: 'app/apps/optionsCookbook/optionsCookbook.tpl.html',
                controller: 'optionsCookbookCtrl as optionsCookbookCtrl',
                size: 'xl',
                resolve: {
                    asAt: function() {
                        return null;
                    },
                    code: function () {
                        return $scope.company.code;
                    },
                    expiries: function() {
                        return chainService($scope.company.code).then(function (chain) {
                            var expiries = [];
                            chain.series.filter(function(s) {
                                return moment().add(3, 'days').isBefore(moment(s.expiry));
                            }).forEach(function(s) {
                                expiries.push({
                                    expiry: s.expiry,
                                    expiryType: s.expiryType
                                });
                            });
                            return expiries;
                        });
                    }
                }
            });

            modalInstance.result.then(function (recipeParams) {
                $http.post('/tradefloor/api/strategy/kitchen', recipeParams).then(function(response) {
                    var whatIfTrades = response.data;
                    var whatIfName = $scope.company.code + ' ' + recipeParams.longName;
                    var newWhatIf = {
                        name : whatIfName,
                        trades : whatIfTrades,
                        shared : false,
                        mine : true
                    };
                    return $http.put('/tradefloor/api/portfolio/' + $rootScope.defaultPortfolio.portfolioId + '/whatifs', newWhatIf).then(function(response) {
                        var data = response.data;
                        return data;
                    }).then(function(whatIf) {
                            $state.go('portfolio', {portfolioId: $rootScope.defaultPortfolio.portfolioId, activeWhatIfId: whatIf.id});
                        }
                    );
                });
            }, function () {
            });


        };

    }])

    .controller('recipeParametersCtrl', ['$scope', '$uibModalInstance', '$window', '$http', 'strategy', 'asAt', 'expiries', function optionsCookbookController($scope, $uibModalInstance, $window, $http, strategy, asAt, expiries) {

        $scope.modalInstance = $uibModalInstance;
        $scope.expiries = expiries;
        $scope.asAt = asAt != null ? moment(asAt) : moment();

        const firstExpiry = $scope.expiries[0];
        const firstMonthlyExpiry = $scope.expiries.filter(p => p.expiryType !== 'WEEKLY')[0];
        const defaultExpiry = firstMonthlyExpiry || firstExpiry;

        $scope.recipeParams = {
            expiry : defaultExpiry,
            style : null
        };

        $scope.exerciseStyles = [
            "AMERICAN",
            "EUROPEAN"
        ];

        $scope.selectStyle = function(style) {
            $scope.recipeParams.style = style;
        };

        $scope.selectExpiry = function(expiry) {
            $scope.recipeParams.expiry = expiry;
        };

        $scope.createStrategy = function() {
            $uibModalInstance.close($scope.recipeParams);
        };

    }]);


